import { NgOptimizedImage } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ImageModule } from 'primeng/image';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AppCommonModule } from '@/common/common.module';
import { UpdateBannerComponent } from '@/common/components/update-banner/update-banner.component';
import { PermissionCheckDirective } from '@/common/directives/permission-check.directive';
import { TruncatePipe } from '@/common/pipes/truncate.pipe';
import { TranslationModule } from '@/modules/i18n';
import { AiChatSidebarComponent } from '@/pages/tiktok/components/ai-chat-sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LayoutComponent } from './layout.component';

@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    LayoutComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    TranslationModule,
    BrowserAnimationsModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    RouterModule,
    AppCommonModule,
    ToastModule,
    MenuModule,
    ButtonModule,
    ChipModule,
    NgOptimizedImage,
    ImageModule,
    OverlayPanelModule,
    PanelMenuModule,
    TieredMenuModule,
    TooltipModule,
    PermissionCheckDirective,
    TruncatePipe,
    AiChatSidebarComponent,
    UpdateBannerComponent,
  ],
  exports: [LayoutComponent],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class LayoutModule {
}
